// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".col-6{flex:0 0 50%}.col-4{flex:0 0 33.333%}.col-3{flex:0 0 25%}.custom-col{flex:0 0 20%}@media only screen and (max-width:1000px){.custom-col{flex:0 0 33.333%}}@media only screen and (max-width:700px){.custom-col{flex:0 0 50%}}@media only screen and (max-width:500px){.custom-col{flex:0 0 48.5%;margin:6px 0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
